export const radii = {
  xxsm: 2,
  xsm: 4,
  xsmx: 6,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 999,
}

export type RadiusKeyType = keyof typeof radii
export const radius = (key: RadiusKeyType) => `${radii[key]}px`
